import React from 'react';
import './Projects.css';

const Projects: React.FC = () => {
    return (
        <div className="projects-container">
            <h1>Our Projects</h1>
            <p>Welcome to the Projects page! Here you can find information about the various projects undertaken by Let's Change Zambia.</p>

            <section className="project-section">
                <div className="project-header">
                    <svg className="project-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20 6h-2V4c0-1.1-.9-2-2-2H8C6.9 2 6 2.9 6 4v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 0H10V4h4v2z"/>
                    </svg>
                    <h2>Clean Cooking</h2>
                </div>
                <p>
                    Promoting safe, affordable, and sustainable cooking solutions to improve health and reduce environmental impact.
                </p>
            </section>

            <section className="project-section">
                <div className="project-header">
                    <svg className="project-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                    </svg>
                    <h2>Environmental Education</h2>
                </div>
                <p>
                    Educating communities about environmental stewardship, conservation, and sustainable practices.
                </p>
            </section>

            <section className="project-section">
                <div className="project-header">
                    <svg className="project-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                    </svg>
                    <h2>Farming as a Business with US (FABUWUS)</h2>
                </div>
                <p>
                    Empowering farmers with business skills, resources, and support to make agriculture profitable and sustainable.
                </p>
            </section>
        </div>
    );
};

export default Projects;